module.exports = __webpack_public_path__ + "4653a9bbe894c5ae41b6c686feee33dd.png";